import { gql } from '@apollo/client';

export const QUERY_TMS_TRANSPORT_FILTER_OPTIONS = gql`
    query QueryTmsTransportFilterOptions($input: TmsTransportFilterOptionsInput!) {
        queryTmsTransportFilterOptions(input: $input) {
            hubs {
                id
                name
            }
            routes {
                id
                name
                allIds
            }
        }
    }
`;
